var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 16.541C11.587 16.541 11.251 16.205 11.251 15.791V3.75C11.251 3.336 11.587 3 12.001 3C12.415 3 12.751 3.336 12.751 3.75V15.791C12.751 16.205 12.415 16.541 12.001 16.541Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 16.541C11.8018 16.541 11.6098 16.462 11.4698 16.32L8.55383 13.393C8.26183 13.099 8.26283 12.624 8.55583 12.332C8.84983 12.04 9.32383 12.04 9.61583 12.334L12.0008 14.729L14.3858 12.334C14.6778 12.04 15.1518 12.04 15.4458 12.332C15.7388 12.624 15.7398 13.099 15.4478 13.393L12.5318 16.32C12.3918 16.462 12.1998 16.541 12.0008 16.541Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1627",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 20,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7.73242H21.9998V21.4764H2V7.73242Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1627)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.575 21.4764H6.435C3.99 21.4764 2 19.4874 2 17.0414V12.1564C2 9.71642 3.985 7.73242 6.426 7.73242H7.367C7.781 7.73242 8.117 8.06842 8.117 8.48242C8.117 8.89642 7.781 9.23242 7.367 9.23242H6.426C4.812 9.23242 3.5 10.5434 3.5 12.1564V17.0414C3.5 18.6604 4.816 19.9764 6.435 19.9764H17.575C19.187 19.9764 20.5 18.6634 20.5 17.0514V12.1674C20.5 10.5484 19.183 9.23242 17.566 9.23242H16.634C16.22 9.23242 15.884 8.89642 15.884 8.48242C15.884 8.06842 16.22 7.73242 16.634 7.73242H17.566C20.011 7.73242 22 9.72242 22 12.1674V17.0514C22 19.4914 20.014 21.4764 17.575 21.4764Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.69aa3590311d5baeea2b49845191cdd5.svg";
export { ForwardRef as ReactComponent };